import Vue from 'vue';
import Router from 'vue-router';
const Index = () => import('./pages/Index.vue')

//import Order from './pages/Order.vue';
const Order = () => import('./pages/Order.vue')
//import AboutUs from './pages/AboutUs.vue';
const AboutUs = () => import('./pages/AboutUs.vue')
//import ContactUs from './pages/ContactUs.vue';
//import OurFarms from './pages/OurFarms.vue';
const OurFarms = () => import('./pages/OurFarms.vue')
//import MainNavbar from './layout/MainNavbar.vue';
const MainNavbar = () => import('./layout/MainNavbar.vue')

const StarterNavbar = () => import('./layout/StarterNavbar.vue')

const OrderNavbar = () => import('./layout/OrderNavbar.vue')
//import MainFooter from './layout/MainFooter.vue';
const MainFooter = () => import('./layout/MainFooter.vue')
//import Covid from './pages/Covid.vue';
const Covid = () => import('./pages/Covid.vue')

const ClubMembership = () => import('./pages/ClubMembership.vue')

const MedcoMembership = () => import('./pages/MedcoMembership.vue')
const MedcoMembership1 = () => import('./pages/MedcoMembership1.vue')

const Mobikwik = () => import('./pages/Mobikwik.vue')
//import notFound from './pages/notFound.vue';
const notFound = () => import('./pages/notFound.vue')
//import Product from './pages/Product.vue';
const Product = () => import('./pages/Product.vue')
//import Privacy from './pages/Privacy.vue';
const Privacy = () => import('./pages/Privacy.vue')
//import Terms from './pages/Terms.vue';
const Terms = () => import('./pages/Terms.vue')
//import Shipping from './pages/Shipping.vue';
const Shipping = () => import('./pages/Shipping.vue')
//import Refund from './pages/Refund.vue';
const Refund = () => import('./pages/Refund.vue')
//import ThankYou from './pages/ThankYou.vue';
const ThankYou = () => import('./pages/ThankYou.vue')
//import PrimeMemberships from './pages/PrimeMemberships.vue';
const PrimeMemberships = () => import('./pages/PrimeMemberships.vue')
//import KnowMemberships from './pages/KnowMemberships.vue';
const KnowMemberships = () => import('./pages/KnowMemberships.vue')
const UserPolicy = () => import('./pages/Policies.vue')

const UserAccountGuide = () => import('./pages/UserAccountGuide.vue')

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
};
Vue.use(Router);
//export function createRouter () {
export default new Router({
  linkExactActiveClass: 'active',
  linkActiveClass: "active",
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'index',
      components: { default: Index, header: MainNavbar },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: 'black' }
      }
    },
    {
      path: '/privacy-policy',
      name: 'privacy-policy',
      components: { default: Privacy, header: OrderNavbar, footer: MainFooter },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: 'black' }
      }
    },
    {
      path: '/terms-condition',
      name: 'terms-condition',
      components: { default: Terms, header: OrderNavbar, footer: MainFooter },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: 'black' }
      }
    },
    {
      path: '/refund-policy',
      name: 'refund-policy',
      components: { default: Refund, header: OrderNavbar, footer: MainFooter },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: 'black' }
      }
    },
    {
      path: '/shipping-policy',
      name: 'shipping-policy',
      components: { default: Shipping, header: OrderNavbar, footer: MainFooter },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: 'black' }
      }
    },
    {
      path: '/thank-you',
      name: 'thank-you',
      components: { default: ThankYou, header: MainNavbar, footer: MainFooter },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: 'black' }
      }
    },
    {
      path: '/Order',
      name: 'order',
      components: { default: Order, header: OrderNavbar, footer: MainFooter },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: 'black' }
      }
    },
    {
      path: '/about',
      name: 'about',
      components: { default: AboutUs, header: OrderNavbar, footer: MainFooter },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: 'black' }
      }
    },
    {
      path: '/our-farms',
      name: 'our-farms',
      components: { default: OurFarms, header: OrderNavbar, footer: MainFooter },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: 'black' }
      }
    },
    {
      path: '/covid',
      name: 'covid',
      components: { default: Covid, },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: 'black' }
      }
    },
    {
      path: '/loyalty',
      name: 'loyalty',
      components: { default: ClubMembership, },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: 'black' }
      }
    },
    {
      path: '/medcobox',
      name: 'medcobox',
      components: { default: MedcoMembership, },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: 'black' }
      }
    },
    {
      path: '/medcobox1',
      name: 'medcobox1',
      components: { default: MedcoMembership1, },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: 'black' }
      }
    },
    {
      path: '/mobikwik',
      name: 'mobikwik',
      components: { default: Mobikwik, },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: 'black' }
      }
    },
    {
      path: '/user-account-guide',
      name: 'user-account-guide',
      components: { default: UserAccountGuide, },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: 'black' }
      }
    },
    {
      path: '*',
      name: 'notFound',
      components: { default: notFound, header: MainNavbar, footer: MainFooter },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: 'black' }
      }
    },
    {
      path: '/product/:url',
      name: 'product',
      components: { default: Product, header: MainNavbar, footer: MainFooter },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: 'black' }
      }
    },
    {
      path: '/prime_membership',
      name: 'prime_membership',
      components: { default: PrimeMemberships, },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: 'black' }
      }
    },
    {
      path: '/know_membership',
      name: 'know_membership',
      components: { default: KnowMemberships, },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: 'black' }
      }
    },
    {
      path: '/user-policy',
      name: 'user-policy',
      components: { default: UserPolicy, },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: 'black' }
      }
    },


  ],
  scrollBehavior: to => {
    if (to.hash) {
      return { selector: to.hash };
    } else {
      return { x: 0, y: 0 };
    }
  }
});
//}
